import {UPDATE_GAME_STUDIO_FREE_SPINS, UPDATE_GAMES_GLOBAL_FREE_SPINS} from "Redux/actions/freeSpins";

let gamesGlobalInitialState = {isLoaded: false, games: []};
let gameStudioInitialState = {isLoaded: false, games: []};

const freeSpinsReducer = (state = {gamesGlobal: gamesGlobalInitialState, gameStudio: gameStudioInitialState}, action) => {
    switch (action.type) {
        case UPDATE_GAMES_GLOBAL_FREE_SPINS:
            return {
                ...state,
                gamesGlobal: {
                    ...state.gamesGlobal,
                    isLoaded: true,
                    games: action.freeSpinsGames,
                }
            };
        case UPDATE_GAME_STUDIO_FREE_SPINS:
            return {
                ...state,
                gameStudio: {
                    ...state.gameStudio,
                    isLoaded: true,
                    games: action.freeSpinsGames,
                }
            };
        default:
            return {
                ...state
            };
    }
};

export default freeSpinsReducer;
